import { Theme } from '@mui/material/styles'

const useStyles = {
  endAdornment: (theme: Theme) => ({
    marginRight: theme.spacing(2),
  }),
}
export default useStyles
